import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, first, map, startWith, switchMap, tap } from 'rxjs/operators';
import { Item } from 'src/app/models/item';
import { ItemsService } from '../items.service';
// import { faCoffee } from '@fortawesome/free-solid-svg-icons';

@Component({
   selector: 'app-items-list',
   templateUrl: './items-list.component.html',
   styleUrls: ['./items-list.component.css'],
})
export class ItemsListComponent implements OnInit {
   searchForm = this.fb.group({
     code: [''],
      brand: [''],
      series: [''],
      category: [''],
      subcategory: [''],
   });

   //  faCoffee = faCoffee;

   categories: object;
   brands: object;
   categoriesList: string[];
   brandsList: string[];
   helpers$: Observable<object[]>;
   helpers: object[];
   categoriesDoc$: Observable<object>;
   brandsDoc$: Observable<object>;

   selectedBrand$: Observable<string>;
   selectedCategory$: Observable<string>;
  //  codeFilled$: Observable<string>;

   seriesList$;
   subcategoriesList$;

   searchResult$: Observable<Item[]>;

   searchField = new FormControl('');
   searchTerm$: Observable<string>;
   searchItems$: Observable<Item[]>;

   constructor(private fb: FormBuilder, private its: ItemsService) {
      // this.helpers$ = this.its.fetchHelpers();
      // this.helpers$.pipe(map((vals) => vals.map((val) => val))).subscribe((val) => (this.helpers = val));
   }

   ngOnInit(): void {
      this.categoriesDoc$ = this.its.fetchHelpersDoc('categories');
      this.categoriesDoc$.subscribe((val) => {
         this.categories = val;
         this.categoriesList = this.decomposeObjects(val);
      });
      this.brandsDoc$ = this.its.fetchHelpersDoc('brands');
      this.brandsDoc$.subscribe((val) => {
         this.brands = val;
         this.brandsList = this.decomposeObjects(val);
      });

      // this.categoriesList = this.decomposeObjects(this.categories);
      // this.brandsList = this.decomposeObjects(this.brands);
      // console.log('Brands: ' + this.brands);
      // console.log('Categories: ' + this.categories);
      // console.log('Brands list: ', this.brandsList);
      // console.log(this.categoriesList);

      // this.selectedBrand$ =
      //   this.searchForm.get('brand').valueChanges
      //   .pipe(
      //     startWith(''),
      //     distinctUntilChanged()
      //   );
      this.selectedBrand$ = this.buildObservableFromFormField('brand');
      this.selectedCategory$ = this.buildObservableFromFormField('category');
      // this.codeFilled$ = this.buildObservableFromFormField('code');

      this.selectedBrand$.subscribe((val) => {
         this.seriesList$ = val && val != '' ? this.brands[val] : '';
         // console.log('seriesList$: ', this.seriesList$);
      });

      this.selectedCategory$.subscribe((val) => {
         this.subcategoriesList$ = val && val != '' ? this.categories[val] : '';
         // console.log('subcatsList$: ', this.subcategoriesList$);
      });

      this.searchItems$ = this.searchField.valueChanges.pipe(
         // startWith(''),
         debounceTime(1000),
         distinctUntilChanged(),
         filter((val) => val.length > 2),
         switchMap((src) => this.its.getItemsByCode(src)),

      );
   }

   onSubmit() {
      const { code, brand, series, category, subcategory } = this.searchForm.value;
      //  console.log(brand, series, category, subcategory);
      this.searchResult$ = this.its.getItemsByFilter(code, brand, series, category, subcategory);
   }

   resetForm() {
      this.searchForm.reset();

      //  .setValue({
      //   brand: 'Marka',
      //   series: 'Seri',
      //   category: 'Kategori',
      //   subcategory: 'Alt kategori'
      //  } )
   }

   buildObservableFromFormField(field: string) {
      return this.searchForm.get(field).valueChanges.pipe(startWith(''), distinctUntilChanged());
   }

   decomposeObjects(obj: Object): string[] {
      let arr = [];
      // for (let prop in obj) {
      //    prop != '' ? arr.push(prop) : null;
      // }
      const keys = Object.keys(obj);
      keys.forEach((key) => {
         arr.push(key);
      });
      return arr;
   }
}
